import React from "react";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import about1 from '../assets/images/Rectangle 539.png'
import about2 from '../assets/images/Rectangle 494.png'

export default function Aboutus() {
  return (
    <>
      {/* <div className="aboutusboxMaine"> */}
      <Container>
        <div className="aboutUsBox">
          <Row>
            <Col className="my-auto" lg={6}>

              <Row>
                <Col className=" mb-2 text-center" md={6} sm={6} lg={12}>
                  <img src={about1} className="img-fluid img1" alt="" />
                  <img src={about2} className="img-fluid img2" alt="" />
                </Col>
              </Row> </Col>
            <Col lg={6} className="aboutcontent">

              <div className="panelHead">
                <h3>About Us</h3>
              </div>
              <p>Terpnash is born from the vision of the illustrious Howard Terpning family, custodians of a rich artistic legacy spanning 75 years.</p>

              <p>In the past, fake copies of Howard’s work were often spread without adequate copyright protection or fair compensation for the artist.</p>
              <p>With recent advancements in Digital Technology, Steven Terpning spotted the opportunity to empower artists and make compensations more fair while expanding globally.</p>

              <p>Thus, Terpnash was conceptualized as a Marketplace for both Physical and Digital Art converted from the artists original artwork,
                 which is art ownership-authenticated and perpetual art resale royalty-enabled in the digital space.</p>
            </Col>

          </Row>
        </div>
      </Container>
      {/* </div> */}
    </>
  )
}